import React from 'react';
import { useAuth } from '../context/AuthContext';
import NDASigningModal from './NDASigningModal';

/**
 * NDAGuard component - shows NDA signing modal for Core Group members
 * who haven't signed the current NDA version
 */
const NDAGuard = ({ children }) => {
  const { ndaStatus, clearNdaRequirement, refreshUser, isAuthenticated } = useAuth();
  
  const handleNdaSigned = () => {
    clearNdaRequirement();
    refreshUser(); // Refresh user data to update NDA status
  };
  
  // Only show modal if user is authenticated and needs to sign NDA
  const showModal = isAuthenticated && ndaStatus?.needsNda && ndaStatus?.template;
  
  return (
    <>
      {children}
      <NDASigningModal
        isOpen={showModal}
        onClose={() => {}} // Can't close without signing
        template={ndaStatus?.template}
        onSigned={handleNdaSigned}
      />
    </>
  );
};

export default NDAGuard;
